import React from 'react';
import useAudioWebsocketApiConnectionContext from '../Contexts/WebsocketConnectionProviders/AudioWebsocketApiConnectionContext/useAudioWebsocketApiConnectionContext';

export default function useAudioServerCommunication() {
  const audioWebsocketConnection = useAudioWebsocketApiConnectionContext();
  const value = React.useMemo(() => audioWebsocketConnection, [audioWebsocketConnection]);
  return value;
}
